import React, { useState } from "react";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import CreateModel from "./AiModels/CreateModel";
const ApiKeys = () => {
  // GeminiAi Keys
  const [isEditingGeminiAi, setIsEditingGeminiAi] = useState(false); // Track if the input is editable

  const [apiKeyGeminiAi, setApiKeyGeminiAi] = useState(
    "AIzaSyA27vzeSnobuj1a67XJd_XXXXXXXXXX"
  );
  const handleEditClickGeminiAi = () => {
    setIsEditingGeminiAi(true); // Enable editing mode
  };
  const handleInputChangeGeminiAi = (e) => {
    setApiKeyGeminiAi(e.target.value); // Update the API key state
  };
  const handleBlurGeminiAi = () => {
    setIsEditingGeminiAi(false); // Disable editing mode when input loses focus
  };
  //End GeminiAi Keys

  // OpenAi keys
  const [isEditingOpenAi, setIsEditingOpenAi] = useState(false); // Track if the input is editable

  const handleInputChangeOpenAi = (e) => {
    setApiKeyOpenAi(e.target.value); // Update the API key state
  };

  const handleBlurOpenAi = () => {
    setIsEditingOpenAi(false); // Disable editing mode when input loses focus
  };
  const handleEditClickOpenAi = () => {
    setIsEditingOpenAi(true); // Enable editing mode
  };
  const [apiKeyOpenAi, setApiKeyOpenAi] = useState(
    "sk-proj-KA3vYIRjJ1gJ81DB4L2uT3BlbkFJtDXXXXXXXXXX"
  );
  //OpenAi End

  return (
    <div className="px-4 py-6">
      <div className="p-[20px] shadow-cs rounded-lg mb-[20px] bg-white">
        <h1 className="text-[16px] md:text-[18px] cursor-pointer font-semibold text-gray-900 mb-2">
          API Keys
        </h1>
        <div className="flex items-center text-sm text-gray-500">
          <a href="/" className="hover:text-gray-700">
            Home
          </a>
          <span className="mx-2">
            <ChevronRightIcon />
          </span>
          <span className="text-gray-700">API keys</span>
        </div>
      </div>
      <div className="p-[14px] shadow-cs rounded-lg mb-[20px] bg-white">
        <div className="flex items-center justify-between mb-[14px] w-full">
          <h1 className="text-[14px] md:text-[16px] font-medium text-[#262323]">
            OpenAi Keys
          </h1>
          <BorderColorIcon
            className="cursor-pointer"
            onClick={handleEditClickOpenAi} // Enable editing on click
          />
        </div>
        <input
          className={`border border-[#dbdbdb]  w-full placeholder-[#2b2b2d] text-[16px] p-[8px] rounded-lg focus-visible:outline-none ${
            isEditingOpenAi ? "bg-white" : "bg-[white]" // Change background to indicate editable state
          }`}
          type="text"
          value={apiKeyOpenAi} // Bind value to state
          onChange={handleInputChangeOpenAi} // Update state on change
          readOnly={!setIsEditingOpenAi} // Make input non-editable unless in editing mode
          onBlur={handleBlurOpenAi} // Disable editing on blur
          placeholder="sk-proj-KA3vYIRjJ1gJ81DB4L2uT3BlbkFJtDXXXXXXXXXX"
        />
      </div>
      <div className="p-[14px] shadow-cs rounded-lg mb-[20px] bg-white">
        <div className="flex items-center justify-between mb-[14px] w-full">
          <h1 className="text-[14px] md:text-[16px] font-medium text-[#262323]">
            GeminiAI keys
          </h1>
          <BorderColorIcon
            className="cursor-pointer"
            onClick={handleEditClickGeminiAi} // Enable editing on click
          />
        </div>
        <input
          className={`border border-[#dbdbdb]  w-full placeholder-[#2b2b2d] text-[16px] p-[8px] rounded-lg focus-visible:outline-none ${
            isEditingGeminiAi ? "bg-white" : "bg-[white]" // Change background to indicate editable state
          }`}
          type="text"
          value={apiKeyGeminiAi} // Bind value to state
          onChange={handleInputChangeGeminiAi} // Update state on change
          readOnly={!isEditingGeminiAi} // Make input non-editable unless in editing mode
          onBlur={handleBlurGeminiAi} // Disable editing on blur
          placeholder="AIzaSyA27vzeSnobuj1a67XJd_XXXXXXXXXX"
        />
      </div>
      <button className="w-[100%] bg-[#27004a] p-[10px] text-[white] rounded-lg">
        Save
      </button>
    </div>
  );
};

export default ApiKeys;
